/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net API
 * OpenAPI spec version: v1
 */

export type LocationKindEnum = typeof LocationKindEnum[keyof typeof LocationKindEnum];


export const LocationKindEnum = {
  SYSTEM: 'system',
  STAR: 'star',
  PLANET: 'planet',
  MOON: 'moon',
  CITY: 'city',
  SPACEPORT: 'spaceport',
  STATION: 'station',
  OUTPOST: 'outpost',
  CLINIC: 'clinic',
  DISTRICT: 'district',
  ASTEROID: 'asteroid',
  ANOMALY: 'anomaly',
  JUMP_POINT: 'jump_point',
  POINT_OF_INTEREST: 'point_of_interest',
  NAV_POINT: 'nav_point',
  OTHER: 'other',
} as const;
